import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Db3DApiBackendClient, QueryParamsForGetUsers } from "src/app/services/api/db3d-api-backend-client.service";
import { UsersDetailsFactory, IUserDetailsApiResponse } from "src/app/factories/user-details-factory";
import { UsersRoleFactory, IUsersRoleApiResponse } from "src/app/factories/user-role-factory";
import { UsersPaginationFactory } from "src/app/factories/users-pagination-factory";
import { UserDetails } from "src/app/data-models/manage-users/user-details.model";
import { UsersRole } from "src/app/data-models/manage-users/user-role.model";
import { UsersPagination } from "src/app/data-models/manage-users/users-pagination.model";

@Injectable({
  providedIn: "root"
})
export class UsersListService {
  private usersDetailsFactory: UsersDetailsFactory;
  private usersRoleFactory: UsersRoleFactory;
  private usersPaginationFactory: UsersPaginationFactory;

  constructor(
    private api: Db3DApiBackendClient,
  ) {
    this.usersDetailsFactory = new UsersDetailsFactory();
    this.usersRoleFactory = new UsersRoleFactory();
    this.usersPaginationFactory = new UsersPaginationFactory();
  }

  public getUsersList(domain: string, queryParams?: QueryParamsForGetUsers): Observable<any> {
    return this.api.getUsersList(domain, queryParams);
  }

  public mapUsers(items: Array<IUserDetailsApiResponse>): UserDetails[] {
    return items.map((item) => this.usersDetailsFactory.createFromBackendApi(item));
  }

  public mapRoles(items: Array<IUsersRoleApiResponse>): UsersRole[] {
    return items.map((item) => this.usersRoleFactory.createFromBackendApi(item));
  }

  public mapPagination(paginationApi: any): UsersPagination {
    return this.usersPaginationFactory.createFromBackendApi(paginationApi);
  }

  public getUsersRolesList(domain: string, wlSlug: string): Observable<any> {
    return this.api.getUsersRolesList(domain, wlSlug);
  }
}
